module.exports = __webpack_public_path__ + "static/media/web-icon.cba967c4.png";